export const translations = {
  fr: {
    nav: {
      home: "Accueil",
      about: "À propos",
      poles: "Nos pôles",
      projects: "Nos réalisations",
      solutions: "Nos solutions",
      contact: "Contact",
      quote: "Demander un devis",
      menu: "Menu",
      close: "Fermer",
    },
    hero: {
      kicker: "Bâtiment — Travaux Publics — Équipements techniques",
      lines: ["Construisons", "vos projets", "avec exigence."],
      subtitle:
        "De l'étude à la réalisation, OMNIBÂT vous accompagne dans tous vos projets de construction, rénovation, équipements techniques et aménagement.",
      ctaQuote: "Demander un devis",
      ctaServices: "Découvrir nos services",
      stats: [
        { value: "6", label: "Pôles d'expertise" },
        { value: "360°", label: "Prise en charge globale" },
        { value: "100%", label: "Engagement qualité" },
      ],
      scroll: "Défiler",
    },
    marquee: [
      "Études & Architecture",
      "BTP & Gros œuvre",
      "Charpente métallique",
      "Équipements techniques",
      "Menuiserie & Vitrerie",
      "Finition & Aménagement",
      "Fourniture & Négoce",
      "Lomé — Togo",
    ],
    promise: {
      chapter: "01 — Notre promesse",
      title: "Un seul partenaire pour construire, équiper et aménager.",
      text: "OMNIBÂT réunit plusieurs expertises complémentaires pour vous offrir une prise en charge globale de vos projets. De l'étude architecturale aux travaux de construction, en passant par les installations techniques, la menuiserie, les finitions et la fourniture de matériaux, nous coordonnons chaque étape avec une exigence constante de qualité, de maîtrise des coûts et de respect des délais.",
      signature: "Bâtir avec exigence, livrer avec confiance.",
    },
    polesSection: {
      chapter: "02 — Nos pôles",
      title: "Six expertises. Une seule exigence.",
      subtitle:
        "OMNIBÂT structure son savoir-faire autour de six pôles complémentaires, capables d'intervenir seuls ou de manière intégrée sur votre projet.",
      discover: "Découvrir le pôle",
      viewAll: "Explorer tous nos pôles",
      servicesLabel: "Prestations",
    },
    poles: [
      {
        slug: "etudes-architecture-construction",
        num: "01",
        title: "Études, Architecture & Construction",
        tagline: "Concevoir. Étudier. Construire.",
        description:
          "De la première esquisse à la remise des clés, notre pôle études et construction pilote la conception architecturale, les études techniques et la réalisation de vos bâtiments.",
        services: [
          "Études de faisabilité",
          "Architecture",
          "Plans 2D et 3D",
          "Études techniques",
          "Génie civil",
          "Calcul et dimensionnement des structures",
          "Gros œuvre",
          "Construction de maisons",
          "Construction de bâtiments",
          "Rénovation et réhabilitation",
          "Construction clé en main",
        ],
      },
      {
        slug: "metallerie-soudure-charpente",
        num: "02",
        title: "Métallerie, Soudure & Charpente",
        tagline: "Des structures solides, conçues pour durer.",
        description:
          "Notre atelier de métallerie conçoit et fabrique des ouvrages métalliques sur mesure, du portail d'entrée aux charpentes industrielles de grande portée.",
        services: [
          "Charpentes métalliques",
          "Structures métalliques",
          "Soudure",
          "Portails",
          "Clôtures",
          "Escaliers métalliques",
          "Garde-corps",
          "Fabrication métallique sur mesure",
          "Ossatures métalliques",
        ],
      },
      {
        slug: "technique-du-batiment",
        num: "03",
        title: "Technique du Bâtiment",
        tagline: "Les installations qui rendent vos bâtiments performants.",
        description:
          "Nous concevons, installons et maintenons l'ensemble des réseaux et équipements techniques qui font la performance et le confort de vos bâtiments.",
        services: [
          "Électricité",
          "Plomberie",
          "Climatisation",
          "Réseaux informatiques",
          "Vidéosurveillance",
          "Contrôle d'accès",
          "Domotique",
          "Solutions énergétiques",
          "Maintenance technique",
        ],
        process: ["Étudier", "Fournir", "Installer", "Mettre en service", "Maintenir"],
      },
      {
        slug: "menuiserie-vitrerie",
        num: "04",
        title: "Menuiserie & Vitrerie",
        tagline: "Des solutions sur mesure pour vos espaces.",
        description:
          "Bois, aluminium ou PVC : nous fabriquons et posons des menuiseries et vitreries adaptées à votre architecture et à vos usages.",
        services: [
          "Menuiserie bois",
          "Menuiserie aluminium",
          "Menuiserie PVC",
          "Portes",
          "Fenêtres",
          "Baies vitrées",
          "Vitrerie",
          "Cloisons vitrées",
          "Aménagements sur mesure",
        ],
      },
      {
        slug: "finition-amenagement",
        num: "05",
        title: "Finition & Aménagement",
        tagline: "Donner à chaque espace son caractère.",
        description:
          "Le détail qui fait la différence : nos équipes de finition subliment vos espaces intérieurs et extérieurs jusqu'au dernier revêtement.",
        services: [
          "Peinture",
          "Décoration intérieure",
          "Carrelage",
          "Revêtements de sols",
          "Revêtements muraux",
          "Plâtrerie",
          "Faux plafonds",
          "Aménagement intérieur",
          "Aménagement extérieur",
          "Travaux de finition",
        ],
      },
      {
        slug: "fourniture-negoce-materiaux",
        num: "06",
        title: "Fourniture & Négoce de Matériaux",
        tagline: "Les matériaux et équipements dont votre projet a besoin.",
        description:
          "Grâce à notre réseau de fournisseurs, nous approvisionnons vos chantiers en matériaux et équipements de qualité, en fourniture seule ou avec pose.",
        services: [
          "Matériaux de construction",
          "Matériel électrique",
          "Matériel de plomberie",
          "Matériel de finition",
          "Quincaillerie",
          "Équipements techniques",
          "Fourniture seule",
          "Fourniture et pose",
        ],
      },
    ],
    solutionsSection: {
      chapter: "03 — Nos solutions",
      title: "Quatre réponses intégrées à vos projets.",
      subtitle:
        "Quelle que soit l'étape où vous vous trouvez, OMNIBÂT propose une solution adaptée : de l'idée au bâtiment livré.",
      items: [
        {
          num: "01",
          title: "Conception",
          text: "Nous transformons votre idée en projet concret grâce à nos études, plans et solutions techniques.",
        },
        {
          num: "02",
          title: "Construction",
          text: "Nous réalisons vos projets avec une coordination rigoureuse des différents corps de métier.",
        },
        {
          num: "03",
          title: "Fourniture & Pose",
          text: "Nous fournissons les matériaux et équipements nécessaires et assurons leur installation.",
        },
        {
          num: "04",
          title: "Rénovation & Aménagement",
          text: "Nous modernisons, réhabilitons et valorisons vos espaces existants.",
        },
      ],
    },
    process: {
      chapter: "04 — Notre processus",
      title: "De votre idée à la réalisation",
      subtitle: "Une méthode claire et éprouvée, en six étapes maîtrisées.",
      steps: [
        { num: "01", title: "Échange", text: "Compréhension de votre besoin et de vos objectifs." },
        { num: "02", title: "Étude", text: "Analyse technique, conception et estimation du projet." },
        { num: "03", title: "Proposition", text: "Présentation de la solution technique et du devis." },
        { num: "04", title: "Planification", text: "Organisation des équipes, matériaux, ressources et calendrier." },
        { num: "05", title: "Réalisation", text: "Exécution des travaux avec suivi et contrôle qualité." },
        { num: "06", title: "Livraison", text: "Contrôle final, réception et accompagnement après travaux." },
      ],
    },
    projectsSection: {
      chapter: "05 — Nos réalisations",
      title: "Des projets qui parlent d'eux-mêmes.",
      subtitle:
        "Villas, bâtiments, ouvrages métalliques, installations techniques : découvrez une sélection de projets menés avec exigence.",
      cta: "Voir toutes nos réalisations",
      filters: [
        { key: "all", label: "Toutes" },
        { key: "maisons", label: "Maisons" },
        { key: "batiments", label: "Bâtiments" },
        { key: "renovation", label: "Rénovation" },
        { key: "metallerie", label: "Métallerie" },
        { key: "electricite", label: "Électricité" },
        { key: "plomberie", label: "Plomberie" },
        { key: "menuiserie", label: "Menuiserie" },
        { key: "amenagement", label: "Aménagement" },
      ],
      location: "Localisation",
      type: "Type de travaux",
      year: "Année",
      viewProject: "Voir le projet",
      close: "Fermer",
      demoNote: "Projets de démonstration — vos réalisations seront publiées ici.",
    },
    why: {
      chapter: "06 — Pourquoi OMNIBÂT",
      title: "L'exigence comme méthode de travail.",
      items: [
        { title: "Expertise", text: "Des compétences techniques couvrant plusieurs corps de métier." },
        { title: "Qualité", text: "Une sélection rigoureuse des matériaux et un contrôle des travaux." },
        { title: "Maîtrise des coûts", text: "Une planification et un suivi permettant de mieux contrôler le budget." },
        { title: "Respect des délais", text: "Une organisation structurée pour assurer le respect du calendrier." },
        { title: "Solution globale", text: "Un interlocuteur capable de coordonner plusieurs étapes de votre projet." },
        { title: "Transparence", text: "Des devis clairs, un suivi du projet et une communication régulière avec le client." },
      ],
    },
    clients: {
      chapter: "07 — Nos clients",
      title: "Un partenaire pour chaque type de projet.",
      items: [
        { title: "Particuliers", text: "Construction, rénovation et aménagement de maisons." },
        { title: "Entreprises", text: "Construction, rénovation et aménagement de locaux professionnels." },
        { title: "Promoteurs immobiliers", text: "Accompagnement technique et réalisation de projets immobiliers." },
        { title: "Institutions & organisations", text: "Travaux, réhabilitation et équipements de bâtiments." },
      ],
    },
    ctaBand: {
      title: "Parlons de votre projet.",
      text: "Construction, rénovation, équipement ou aménagement : décrivez-nous votre besoin, notre équipe vous répond rapidement.",
      button: "Demander un devis",
      whatsapp: "Discuter sur WhatsApp",
    },
    about: {
      chapter: "À propos",
      title: "Construire aujourd'hui les espaces de demain.",
      p1: "OMNIBÂT est une entreprise spécialisée dans le bâtiment et les solutions techniques associées. Notre mission est de proposer à nos clients des solutions fiables, adaptées à leurs besoins et maîtrisées sur les plans technique, financier et opérationnel.",
      p2: "Nous intervenons sur différents types de projets, de la construction neuve à la rénovation, en passant par les installations techniques, la métallerie, la menuiserie, les finitions et la fourniture de matériaux.",
      p3: "Notre ambition est de devenir une référence dans le secteur de la construction et des solutions immobilières en Afrique de l'Ouest.",
      missionTitle: "Notre mission",
      mission: "Proposer des solutions fiables, adaptées aux besoins de chaque client et maîtrisées sur les plans technique, financier et opérationnel.",
      visionTitle: "Notre vision",
      vision: "Devenir une référence de la construction et des solutions immobilières en Afrique de l'Ouest.",
      valuesTitle: "Nos valeurs",
      values: ["Exigence", "Confiance", "Transparence", "Qualité", "Engagement"],
      cta: "Découvrir nos pôles",
    },
    polesPage: {
      chapter: "Nos pôles",
      title: "Six pôles d'expertise, une coordination unique.",
      subtitle:
        "Chaque pôle OMNIBÂT réunit des spécialistes, des équipements dédiés et une méthodologie éprouvée. Ensemble, ils couvrent l'intégralité du cycle de vie d'un bâtiment.",
      cta: "Demander un devis pour ce pôle",
      processLabel: "Notre méthode",
    },
    solutionsPage: {
      chapter: "Nos solutions",
      title: "De l'idée au bâtiment livré.",
      subtitle:
        "Quatre grandes solutions qui s'articulent pour répondre à l'ensemble de vos besoins : concevoir, construire, équiper et transformer.",
      cta: "Démarrer votre projet",
    },
    projectsPage: {
      chapter: "Nos réalisations",
      title: "La preuve par les projets.",
      subtitle:
        "Parcourez nos réalisations par catégorie : maisons, bâtiments, rénovations, ouvrages métalliques, installations techniques et aménagements.",
    },
    quote: {
      chapter: "Demande de devis",
      title: "Parlons de votre projet.",
      intro:
        "Vous avez un projet de construction, rénovation, équipement ou aménagement ? Décrivez-nous votre besoin. Notre équipe étudiera votre demande et vous contactera pour échanger sur votre projet.",
      sections: { identity: "Vos coordonnées", project: "Votre projet", details: "Détails & documents" },
      fields: {
        name: "Nom et prénom",
        company: "Entreprise",
        companyOptional: "optionnel",
        phone: "Téléphone",
        whatsapp: "WhatsApp",
        email: "Email",
        city: "Ville / Localisation du projet",
        projectType: "Type de projet",
        service: "Service recherché",
        budget: "Budget estimatif",
        deadline: "Délai souhaité",
        description: "Description du projet",
        files: "Fichiers, photos ou plans",
        filesHint: "JPG, PNG ou PDF — 10 Mo max par fichier, 5 fichiers maximum.",
        filesButton: "Ajouter des fichiers",
      },
      placeholders: {
        name: "Ex. Kossi Mensah",
        company: "Nom de votre entreprise",
        phone: "+228 -- -- -- --",
        whatsapp: "+228 -- -- -- --",
        email: "vous@exemple.com",
        city: "Ex. Lomé — Adidogomé",
        description: "Décrivez votre projet : nature des travaux, surface, contraintes particulières…",
        select: "Sélectionner…",
      },
      projectTypes: [
        "Construction",
        "Rénovation",
        "Architecture",
        "Études techniques",
        "Électricité",
        "Plomberie",
        "Climatisation",
        "Métallerie",
        "Menuiserie",
        "Finition",
        "Fourniture de matériaux",
        "Autre",
      ],
      budgets: [
        "Moins de 10 millions FCFA",
        "10 – 50 millions FCFA",
        "50 – 150 millions FCFA",
        "150 – 500 millions FCFA",
        "Plus de 500 millions FCFA",
        "À définir ensemble",
      ],
      deadlines: [
        "Dès que possible",
        "Sous 3 mois",
        "3 à 6 mois",
        "6 à 12 mois",
        "Plus de 12 mois",
      ],
      submit: "Envoyer ma demande",
      sending: "Envoi en cours…",
      successTitle: "Merci pour votre demande.",
      successText: "Notre équipe vous contactera prochainement.",
      successCta: "Retour à l'accueil",
      errorText: "Une erreur est survenue. Merci de réessayer ou de nous contacter directement.",
      required: "Champ requis",
    },
    contact: {
      chapter: "Contact",
      title: "Une équipe à votre écoute.",
      subtitle:
        "Par téléphone, WhatsApp, email ou via le formulaire : choisissez le canal qui vous convient, nous répondons rapidement.",
      infoTitle: "Nos coordonnées",
      phone: "Téléphone",
      whatsapp: "WhatsApp",
      email: "Email",
      address: "Adresse",
      hours: "Horaires d'ouverture",
      hoursValue: "Lun – Ven : 8h00 – 18h00 · Sam : 9h00 – 13h00",
      formTitle: "Écrivez-nous",
      fields: {
        name: "Nom et prénom",
        email: "Email",
        phone: "Téléphone",
        subject: "Sujet",
        message: "Message",
      },
      placeholders: {
        name: "Ex. Kossi Mensah",
        email: "vous@exemple.com",
        phone: "+228 -- -- -- --",
        subject: "Objet de votre message",
        message: "Votre message…",
      },
      submit: "Envoyer le message",
      sending: "Envoi en cours…",
      successTitle: "Message envoyé.",
      successText: "Merci pour votre message. Notre équipe vous répondra rapidement.",
      errorText: "Une erreur est survenue. Merci de réessayer.",
      callNow: "Appeler maintenant",
      whatsappCta: "Écrire sur WhatsApp",
      mapTitle: "Nous trouver",
    },
    footer: {
      tagline: "Bâtir avec exigence, livrer avec confiance.",
      description:
        "Entreprise de bâtiment, travaux publics, construction, équipements techniques, fourniture de matériaux et aménagement — Lomé, Togo.",
      companyTitle: "Entreprise",
      servicesTitle: "Services",
      contactTitle: "Contact",
      company: [
        { label: "À propos", to: "/a-propos" },
        { label: "Nos pôles", to: "/poles" },
        { label: "Nos réalisations", to: "/realisations" },
        { label: "Contact", to: "/contact" },
      ],
      services: [
        { label: "Construction", to: "/poles" },
        { label: "Études & architecture", to: "/poles" },
        { label: "Technique du bâtiment", to: "/poles" },
        { label: "Métallerie", to: "/poles" },
        { label: "Menuiserie", to: "/poles" },
        { label: "Finition", to: "/poles" },
        { label: "Matériaux", to: "/poles" },
      ],
      rights: "© 2026 OMNIBÂT — Tous droits réservés.",
    },
    whatsapp: {
      aria: "Discuter sur WhatsApp",
      message: "Bonjour OMNIBÂT, je souhaite échanger au sujet d'un projet.",
      menuTitle: "Comment pouvons-nous vous aider ?",
      menuSubtitle: "Choisissez un sujet — votre message est déjà prêt.",
      options: [
        { key: "construction", label: "Construction", message: "Bonjour OMNIBÂT, j'ai un projet de construction et je souhaite échanger avec votre équipe." },
        { key: "renovation", label: "Rénovation", message: "Bonjour OMNIBÂT, je souhaite rénover ou réhabiliter un bâtiment. Pouvons-nous en discuter ?" },
        { key: "metallerie", label: "Métallerie & charpente", message: "Bonjour OMNIBÂT, j'ai besoin d'un ouvrage de métallerie, soudure ou charpente métallique." },
        { key: "technique", label: "Électricité, plomberie, climatisation", message: "Bonjour OMNIBÂT, j'ai besoin d'une installation technique (électricité, plomberie, climatisation, domotique…)." },
        { key: "menuiserie", label: "Menuiserie & vitrerie", message: "Bonjour OMNIBÂT, je souhaite des menuiseries ou vitreries sur mesure." },
        { key: "materiaux", label: "Fourniture de matériaux", message: "Bonjour OMNIBÂT, je souhaite un devis pour de la fourniture de matériaux ou d'équipements." },
        { key: "autre", label: "Autre question", message: "Bonjour OMNIBÂT, j'ai une question au sujet d'un projet." },
      ],
    },
    common: {
      phone: "+228 90 92 11 14",
      phoneRaw: "+22890921114",
      whatsappNumber: "22890921114",
      email: "infos@omnibat.pro",
      address: "Lomé — Adidogomé Yokoé, Togo",
    },
  },
  en: {
    nav: {
      home: "Home",
      about: "About",
      poles: "Our Divisions",
      projects: "Our Work",
      solutions: "Our Solutions",
      contact: "Contact",
      quote: "Request a Quote",
      menu: "Menu",
      close: "Close",
    },
    hero: {
      kicker: "Building — Civil Works — Technical Systems",
      lines: ["We build your", "projects with", "rigour."],
      subtitle:
        "From study to delivery, OMNIBÂT supports all your construction, renovation, technical systems and fit-out projects.",
      ctaQuote: "Request a quote",
      ctaServices: "Explore our services",
      stats: [
        { value: "6", label: "Expertise divisions" },
        { value: "360°", label: "End-to-end delivery" },
        { value: "100%", label: "Quality commitment" },
      ],
      scroll: "Scroll",
    },
    marquee: [
      "Studies & Architecture",
      "Civil Works & Structure",
      "Steel Frameworks",
      "Technical Systems",
      "Joinery & Glazing",
      "Finishing & Fit-out",
      "Materials Supply",
      "Lomé — Togo",
    ],
    promise: {
      chapter: "01 — Our promise",
      title: "One partner to build, equip and fit out.",
      text: "OMNIBÂT brings together complementary expertise to deliver end-to-end management of your projects. From architectural design to construction works, technical installations, joinery, finishes and materials supply, we coordinate every step with a constant demand for quality, cost control and schedule compliance.",
      signature: "Build with rigour, deliver with confidence.",
    },
    polesSection: {
      chapter: "02 — Our divisions",
      title: "Six areas of expertise. One standard of rigour.",
      subtitle:
        "OMNIBÂT structures its know-how around six complementary divisions, able to operate independently or as one integrated team on your project.",
      discover: "Explore the division",
      viewAll: "Explore all divisions",
      servicesLabel: "Services",
    },
    poles: [
      {
        slug: "etudes-architecture-construction",
        num: "01",
        title: "Studies, Architecture & Construction",
        tagline: "Design. Engineer. Build.",
        description:
          "From the first sketch to handover, our design and construction division drives architectural design, technical studies and the delivery of your buildings.",
        services: [
          "Feasibility studies",
          "Architecture",
          "2D & 3D plans",
          "Technical studies",
          "Civil engineering",
          "Structural calculation & sizing",
          "Structural works",
          "Home construction",
          "Building construction",
          "Renovation & rehabilitation",
          "Turnkey construction",
        ],
      },
      {
        slug: "metallerie-soudure-charpente",
        num: "02",
        title: "Metalwork, Welding & Steel Framing",
        tagline: "Solid structures, built to last.",
        description:
          "Our metalwork shop designs and fabricates custom steel works, from entrance gates to long-span industrial frameworks.",
        services: [
          "Steel frameworks",
          "Metal structures",
          "Welding",
          "Gates",
          "Fencing",
          "Metal staircases",
          "Guardrails",
          "Custom metal fabrication",
          "Steel frames",
        ],
      },
      {
        slug: "technique-du-batiment",
        num: "03",
        title: "Building Technical Systems",
        tagline: "The installations that make your buildings perform.",
        description:
          "We design, install and maintain all the networks and technical equipment behind the performance and comfort of your buildings.",
        services: [
          "Electrical systems",
          "Plumbing",
          "Air conditioning",
          "IT networks",
          "CCTV surveillance",
          "Access control",
          "Home automation",
          "Energy solutions",
          "Technical maintenance",
        ],
        process: ["Study", "Supply", "Install", "Commission", "Maintain"],
      },
      {
        slug: "menuiserie-vitrerie",
        num: "04",
        title: "Joinery & Glazing",
        tagline: "Made-to-measure solutions for your spaces.",
        description:
          "Wood, aluminium or PVC: we manufacture and install joinery and glazing adapted to your architecture and your uses.",
        services: [
          "Wood joinery",
          "Aluminium joinery",
          "PVC joinery",
          "Doors",
          "Windows",
          "Bay windows",
          "Glazing",
          "Glass partitions",
          "Custom fittings",
        ],
      },
      {
        slug: "finition-amenagement",
        num: "05",
        title: "Finishing & Fit-out",
        tagline: "Giving every space its character.",
        description:
          "The detail that makes the difference: our finishing teams elevate your interior and exterior spaces down to the last coating.",
        services: [
          "Painting",
          "Interior decoration",
          "Tiling",
          "Floor coverings",
          "Wall coverings",
          "Plastering",
          "Suspended ceilings",
          "Interior fit-out",
          "Exterior landscaping",
          "Finishing works",
        ],
      },
      {
        slug: "fourniture-negoce-materiaux",
        num: "06",
        title: "Materials Supply & Trading",
        tagline: "The materials and equipment your project needs.",
        description:
          "Through our supplier network, we supply your sites with quality materials and equipment — supply-only or supply-and-install.",
        services: [
          "Construction materials",
          "Electrical equipment",
          "Plumbing equipment",
          "Finishing materials",
          "Hardware",
          "Technical equipment",
          "Supply only",
          "Supply and installation",
        ],
      },
    ],
    solutionsSection: {
      chapter: "03 — Our solutions",
      title: "Four integrated answers to your projects.",
      subtitle:
        "Wherever you stand in your journey, OMNIBÂT has an adapted solution: from idea to delivered building.",
      items: [
        {
          num: "01",
          title: "Design",
          text: "We turn your idea into a concrete project through our studies, plans and technical solutions.",
        },
        {
          num: "02",
          title: "Construction",
          text: "We deliver your projects with rigorous coordination of all trades.",
        },
        {
          num: "03",
          title: "Supply & Installation",
          text: "We supply the required materials and equipment and handle their installation.",
        },
        {
          num: "04",
          title: "Renovation & Fit-out",
          text: "We modernise, rehabilitate and enhance your existing spaces.",
        },
      ],
    },
    process: {
      chapter: "04 — Our process",
      title: "From your idea to delivery",
      subtitle: "A clear, proven method in six controlled steps.",
      steps: [
        { num: "01", title: "Discussion", text: "Understanding your needs and objectives." },
        { num: "02", title: "Study", text: "Technical analysis, design and project estimation." },
        { num: "03", title: "Proposal", text: "Presentation of the technical solution and quotation." },
        { num: "04", title: "Planning", text: "Organisation of teams, materials, resources and schedule." },
        { num: "05", title: "Execution", text: "Works carried out with monitoring and quality control." },
        { num: "06", title: "Handover", text: "Final inspection, acceptance and post-works support." },
      ],
    },
    projectsSection: {
      chapter: "05 — Our work",
      title: "Projects that speak for themselves.",
      subtitle:
        "Villas, buildings, steel structures, technical installations: discover a selection of projects delivered with rigour.",
      cta: "View all our projects",
      filters: [
        { key: "all", label: "All" },
        { key: "maisons", label: "Homes" },
        { key: "batiments", label: "Buildings" },
        { key: "renovation", label: "Renovation" },
        { key: "metallerie", label: "Metalwork" },
        { key: "electricite", label: "Electrical" },
        { key: "plomberie", label: "Plumbing" },
        { key: "menuiserie", label: "Joinery" },
        { key: "amenagement", label: "Fit-out" },
      ],
      location: "Location",
      type: "Type of works",
      year: "Year",
      viewProject: "View project",
      close: "Close",
      demoNote: "Demo projects — your real achievements will be published here.",
    },
    why: {
      chapter: "06 — Why OMNIBÂT",
      title: "Rigour as a working method.",
      items: [
        { title: "Expertise", text: "Technical skills spanning multiple building trades." },
        { title: "Quality", text: "Rigorous materials selection and works supervision." },
        { title: "Cost control", text: "Planning and monitoring that keep your budget under control." },
        { title: "On-time delivery", text: "A structured organisation that protects your schedule." },
        { title: "End-to-end solution", text: "A single partner coordinating every stage of your project." },
        { title: "Transparency", text: "Clear quotations, project follow-up and regular client communication." },
      ],
    },
    clients: {
      chapter: "07 — Our clients",
      title: "A partner for every kind of project.",
      items: [
        { title: "Homeowners", text: "Construction, renovation and fit-out of private homes." },
        { title: "Businesses", text: "Construction, renovation and fit-out of professional premises." },
        { title: "Property developers", text: "Technical support and delivery of real-estate projects." },
        { title: "Institutions & organisations", text: "Works, rehabilitation and building equipment." },
      ],
    },
    ctaBand: {
      title: "Let's talk about your project.",
      text: "Construction, renovation, equipment or fit-out: tell us what you need, our team will get back to you quickly.",
      button: "Request a quote",
      whatsapp: "Chat on WhatsApp",
    },
    about: {
      chapter: "About us",
      title: "Building today the spaces of tomorrow.",
      p1: "OMNIBÂT is a company specialised in building and associated technical solutions. Our mission is to provide our clients with reliable solutions, adapted to their needs and controlled on the technical, financial and operational levels.",
      p2: "We work on all types of projects, from new construction to renovation, including technical installations, metalwork, joinery, finishes and materials supply.",
      p3: "Our ambition is to become a reference in construction and real-estate solutions in West Africa.",
      missionTitle: "Our mission",
      mission: "Deliver reliable solutions, tailored to each client's needs and controlled technically, financially and operationally.",
      visionTitle: "Our vision",
      vision: "Become a reference for construction and real-estate solutions in West Africa.",
      valuesTitle: "Our values",
      values: ["Rigour", "Trust", "Transparency", "Quality", "Commitment"],
      cta: "Explore our divisions",
    },
    polesPage: {
      chapter: "Our divisions",
      title: "Six areas of expertise, one coordination.",
      subtitle:
        "Each OMNIBÂT division brings together specialists, dedicated equipment and a proven methodology. Together, they cover the entire life cycle of a building.",
      cta: "Request a quote for this division",
      processLabel: "Our method",
    },
    solutionsPage: {
      chapter: "Our solutions",
      title: "From idea to delivered building.",
      subtitle:
        "Four major solutions that combine to cover all your needs: design, build, equip and transform.",
      cta: "Start your project",
    },
    projectsPage: {
      chapter: "Our work",
      title: "Proof through projects.",
      subtitle:
        "Browse our projects by category: homes, buildings, renovations, steel structures, technical installations and fit-outs.",
    },
    quote: {
      chapter: "Quote request",
      title: "Let's talk about your project.",
      intro:
        "Planning a construction, renovation, equipment or fit-out project? Tell us what you need. Our team will review your request and contact you to discuss your project.",
      sections: { identity: "Your details", project: "Your project", details: "Details & documents" },
      fields: {
        name: "Full name",
        company: "Company",
        companyOptional: "optional",
        phone: "Phone",
        whatsapp: "WhatsApp",
        email: "Email",
        city: "City / Project location",
        projectType: "Project type",
        service: "Service needed",
        budget: "Estimated budget",
        deadline: "Desired timeline",
        description: "Project description",
        files: "Files, photos or plans",
        filesHint: "JPG, PNG or PDF — max 10 MB per file, up to 5 files.",
        filesButton: "Add files",
      },
      placeholders: {
        name: "E.g. Kossi Mensah",
        company: "Your company name",
        phone: "+228 -- -- -- --",
        whatsapp: "+228 -- -- -- --",
        email: "you@example.com",
        city: "E.g. Lomé — Adidogomé",
        description: "Describe your project: type of works, surface, specific constraints…",
        select: "Select…",
      },
      projectTypes: [
        "Construction",
        "Renovation",
        "Architecture",
        "Technical studies",
        "Electrical",
        "Plumbing",
        "Air conditioning",
        "Metalwork",
        "Joinery",
        "Finishing",
        "Materials supply",
        "Other",
      ],
      budgets: [
        "Under 10M FCFA",
        "10 – 50M FCFA",
        "50 – 150M FCFA",
        "150 – 500M FCFA",
        "Over 500M FCFA",
        "To be defined together",
      ],
      deadlines: [
        "As soon as possible",
        "Within 3 months",
        "3 to 6 months",
        "6 to 12 months",
        "Over 12 months",
      ],
      submit: "Send my request",
      sending: "Sending…",
      successTitle: "Thank you for your request.",
      successText: "Our team will contact you shortly.",
      successCta: "Back to home",
      errorText: "Something went wrong. Please try again or contact us directly.",
      required: "Required field",
    },
    contact: {
      chapter: "Contact",
      title: "A team that listens.",
      subtitle:
        "By phone, WhatsApp, email or through the form: choose the channel that suits you, we answer quickly.",
      infoTitle: "Contact details",
      phone: "Phone",
      whatsapp: "WhatsApp",
      email: "Email",
      address: "Address",
      hours: "Opening hours",
      hoursValue: "Mon – Fri: 8:00 AM – 6:00 PM · Sat: 9:00 AM – 1:00 PM",
      formTitle: "Write to us",
      fields: {
        name: "Full name",
        email: "Email",
        phone: "Phone",
        subject: "Subject",
        message: "Message",
      },
      placeholders: {
        name: "E.g. Kossi Mensah",
        email: "you@example.com",
        phone: "+228 -- -- -- --",
        subject: "Subject of your message",
        message: "Your message…",
      },
      submit: "Send message",
      sending: "Sending…",
      successTitle: "Message sent.",
      successText: "Thank you for your message. Our team will reply shortly.",
      errorText: "Something went wrong. Please try again.",
      callNow: "Call now",
      whatsappCta: "Message on WhatsApp",
      mapTitle: "Find us",
    },
    footer: {
      tagline: "Build with rigour, deliver with confidence.",
      description:
        "Building, civil works, construction, technical systems, materials supply and fit-out company — Lomé, Togo.",
      companyTitle: "Company",
      servicesTitle: "Services",
      contactTitle: "Contact",
      company: [
        { label: "About", to: "/a-propos" },
        { label: "Our divisions", to: "/poles" },
        { label: "Our work", to: "/realisations" },
        { label: "Contact", to: "/contact" },
      ],
      services: [
        { label: "Construction", to: "/poles" },
        { label: "Studies & architecture", to: "/poles" },
        { label: "Building technical systems", to: "/poles" },
        { label: "Metalwork", to: "/poles" },
        { label: "Joinery", to: "/poles" },
        { label: "Finishing", to: "/poles" },
        { label: "Materials", to: "/poles" },
      ],
      rights: "© 2026 OMNIBÂT — All rights reserved.",
    },
    whatsapp: {
      aria: "Chat on WhatsApp",
      message: "Hello OMNIBÂT, I would like to discuss a project.",
      menuTitle: "How can we help you?",
      menuSubtitle: "Pick a topic — your message is already written.",
      options: [
        { key: "construction", label: "Construction", message: "Hello OMNIBÂT, I have a construction project and would like to talk to your team." },
        { key: "renovation", label: "Renovation", message: "Hello OMNIBÂT, I would like to renovate or rehabilitate a building. Can we discuss it?" },
        { key: "metallerie", label: "Metalwork & steel framing", message: "Hello OMNIBÂT, I need metalwork, welding or steel framing services." },
        { key: "technique", label: "Electrical, plumbing, AC", message: "Hello OMNIBÂT, I need a technical installation (electrical, plumbing, air conditioning, home automation…)." },
        { key: "menuiserie", label: "Joinery & glazing", message: "Hello OMNIBÂT, I would like custom joinery or glazing." },
        { key: "materiaux", label: "Materials supply", message: "Hello OMNIBÂT, I would like a quote for materials or equipment supply." },
        { key: "autre", label: "Other question", message: "Hello OMNIBÂT, I have a question about a project." },
      ],
    },
    common: {
      phone: "+228 90 92 11 14",
      phoneRaw: "+22890921114",
      whatsappNumber: "22890921114",
      email: "infos@omnibat.pro",
      address: "Lomé — Adidogomé Yokoé, Togo",
    },
  },
};
